"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _SpecialOffers = _interopRequireDefault(require("./../../SpecialOffers"));
var _Title = _interopRequireDefault(require("../../../Title"));
// import SMEFreeCard from './../../SEMFreeCard';

// import BrandEquity from '../BrandEquity';
function ProductBenefit(props) {
  var _a = props.style,
    style = _a === void 0 ? {} : _a;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'student-product-benefit-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: props === null || props === void 0 ? void 0 : props.mainTitle
  }), /*#__PURE__*/_react["default"].createElement("h4", {
    className: 'student-product-benefit-container__h4'
  }, props === null || props === void 0 ? void 0 : props.smallTitle), /*#__PURE__*/_react["default"].createElement(_SpecialOffers["default"], {
    leftTitle: '用量越多，折扣越多',
    leftContent: '一键报名所有场景，现在参与最高可达400美元返利',
    leftRuleTxt: 'Rule of activity',
    btnTxt: '立即报名',
    onCallback: function onCallback() {
      console.log(11);
    },
    toastTxt: '抱歉，您未达到报名条件!!',
    rightList: [{
      rightTitle: 'Spend USD 50-399',
      txt: 'Save',
      num: '20%'
    }, {
      rightTitle: 'Spend USD 50-399',
      txt: 'Save',
      num: '21%'
    }, {
      rightTitle: 'Spend USD 50-399',
      txt: 'Save',
      num: '22%'
    }],
    btnConfiguration: {
      richTextContent: "<div>\n            1\u3001\u7528\u6237\u8D2D\u4E70\u8BE5\u4EA7\u54C1\uFF0C\u7D2F\u79EF\u6D88\u8D39\u91D1\u989D\u5C06\u572820\u5929\u540E\u5982\u6EE1\u8DB3\u989D\u5EA6\u5C06\u8F6C\u4E3A\u5BF9\u5E94\u7684\u4EE3\u91D1\u5238<br/>\n            2\u3001\u8BE5\u4EE3\u91D1\u5238\u6BCF\u7528\u6237\u9650\u98861\u5F20<br/>\n            3\u3001\u8BE5\u4EE3\u91D1\u5238\u4E0D\u652F\u6301\u8D2D\u4E70\u5176\u4ED6\u6D3B\u52A8\u4EA7\u54C1<br/>\n            4\u3001\u5728\u8BE5\u6D3B\u52A8\u9886\u53D6\u7684\u4EE3\u91D1\u5238\uFF0C\u4EC5\u53EF\u5728\u8D2D\u4E70\u4E91\u670D\u52A1\u5668CVM\u548C\u8F7B\u91CF\u5E94\u7528\u670D\u52A1\u5668Lighthouse\u65F6\u4F7F\u7528<br/>\n            5\u3001\u4EE3\u91D1\u5238\u81EA\u53D1\u653E\u8D7715\u5929\u6709\u6548</div>",
      modalTitle: '规则说明'
    }
  }));
}
var _default = exports["default"] = ProductBenefit;